import HttpService from './http';

export default class AuthHttpService {
  static startVerification = async payload => {
    const url = '/v1.0/verify/nexmo/start';
    return await HttpService.post(url, payload, false);
  };

  static checkVerification = async payload => {
    const url = '/v1.0/verify/nexmo/check';
    return await HttpService.post(url, payload, false);
  };

  static setPassword = async payload => {
    const url = '/v1.0/auth/set/password/phone';
    return await HttpService.post(url, payload, false);
  };

  static register = async payload => {
    const url = '/v2.0/users';
    return await HttpService.post(url, payload, false);
  };

  static login = async payload => {
    const url = '/v2.0/auth/login';
    return await HttpService.post(url, payload, false);
  };

  static logout = async () => {
    const url = '/v1.0/auth/logout';
    return await HttpService.delete(url, true);
  };

  static checkTerm = async payload => {
    const url = '/v2.0/auth/term/check';
    return await HttpService.post(url, payload, false);
  }
}
